// src/components/UpcomingShowsWidget.js
import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { Link } from 'react-router-dom';
import './UpcomingShowsWidget.css';

const GET_UPCOMING_SHOWS = gql`
  query GetUpcomingShows {
    getAllShows(filter: { upcomingOnly: true, limit: 3 }) {
      id
      title
      date
      startTime
      artistName
      venueName
      artistPageId
      venuePageId
    }
  }
`;

const UpcomingShowsWidget = () => {
  const { loading, error, data } = useQuery(GET_UPCOMING_SHOWS);

  if (loading) return <div className="widget-container">Loading shows...</div>;
  if (error) return <div className="widget-container">Error loading shows.</div>;

  const shows = data.getAllShows;

  return (
    <div className="widget-container">
      <h3>🎫 Upcoming Shows</h3>
      <ul className="widget-list">
        {shows.map((show) => (
          <li key={show.id} className="widget-item">
            <div className="widget-title">
            <Link to={`/show/${show.id}`} className="widget-title-link">
              <div className="widget-title">{show.title}</div>
            </Link>
            </div>
            <div className="widget-meta">
              
            <span>
  {new Date(show.date).toLocaleDateString('en-AU', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })}
</span>
              {show.startTime && <span> @ {show.startTime}</span>}
            </div>
            {show.artistName && <div className="widget-artist">
            🎤 <Link to={`/artist/${show.artistPageId}`}>
                  {show.artistName}
                </Link>
                </div>}
            {show.venueName && <div className="widget-venue">📍 
            📍 <Link to={`/venuepage/${show.venuePageId}`}>
                  {show.venueName}
                </Link>
                </div>}
          </li>
        ))}
      </ul>
      <div className="widget-footer">
        <Link to="/upcomingshows" className="widget-more-link">See All Shows →</Link>
      </div>
    </div>
  );
};

export default UpcomingShowsWidget;
